import React from 'react'
import UserPanelTitle from '../UserPanelTitle/UserPanelTitle'
import './UserHomeLastCourse.css'
import {IoBasketOutline} from 'react-icons/io5'
import UserPanelEmptyAlert from '../UserPanelEmptyAlert/UserPanelEmptyAlert'
export default function UserHomeLastCourse() {
  return (
    <div className='user-home-last-course'>
      <UserPanelTitle title='آخرین دوره های خریداری شده' />
      <UserPanelEmptyAlert title='آموزشی خریداری نشد' icon={<IoBasketOutline />}/>
    </div>
  )
}
